'use es6';

import https from 'hub-http/clients/apiClient';
const BASE_URL = 'lead-flows/v1/lead-flows';
export function getForm(guid) {
  return https.get(`${BASE_URL}/${guid}`);
}
export function createForm(data) {
  return https.post(BASE_URL, {
    data
  });
}
export function deleteForm(guid) {
  return https.delete(`${BASE_URL}/${guid}`);
}
export function cloneForm({
  guid,
  name,
  businessUnitId
}) {
  return https.post(`${BASE_URL}/${guid}/clone`, {
    data: {
      name,
      businessUnitId
    }
  });
}
export function patchForm(guid, data) {
  return https.patch(`${BASE_URL}/${guid}`, {
    data
  });
}